import { createSelector } from '@reduxjs/toolkit'

import { getCockpitSubCategoriesByCategory } from '../../lib/getCockpitSubCategoriesByCategory'

import { selectCockpitActualsAndTargetsSettings } from './selectCockpitActualsAndTargetsSettings'

export const selectCockpitSubCategoriesByCategory = createSelector(
  selectCockpitActualsAndTargetsSettings,
  getCockpitSubCategoriesByCategory
)
